import ForgotPasswordForm from '../components/Auth/ForgotPassword';

const ForgotPasswordPage = () => <ForgotPasswordForm />;

export default ForgotPasswordPage;